<template>
	<div class="link-img" :style="{width:`${width}px`,height:`${height}px`}" :class="[`link-img-${shape}`,{'link-img-disabled':!!disabled}]">
		<img v-if="!!smallUrl && fileStatus" :src="smallUrl" @click.stop="preview">
		<video v-else :src="smallUrl" height="100%" @click="preview"></video>
		<link-icon icon="icon-upload" v-else class="link-img-empty-icon"/>

		<div class="link-img-loading" v-if="loading">
			<link-icon icon="icon-loading" loading/>
		</div>

		<div class="link-img-operation">
			<div class="link-img-operation-upload" @click.stop="lv_upload">
				<link-icon icon="icon-upload"/>
			</div>
			<div class="link-img-operation-clear" @click.stop="lv_delete">
				<link-icon icon="icon-trash"/>
			</div>
		</div>
	</div>
</template>

<script>

    export default {
        name: "link-img",
        props: {
            row: {required: true},                          //绑定的对象
            headId: {type: String},                         //图片上传的头id
            moduleType: {},                                 //图片的模块

            idKey: {type: String, required: true},          //图片id存放的id
            bigUrlKey: {type: String,},                     //图片大图key
            smallUrlKey: {type: String, required: true},    //图片小图key

            width: {type: Number, default: 100},            // 每张图片显示宽度
            height: {type: Number, default: 100},           // 每张图片显示高度

            shape: {type: String, default: 'round', validator: val => LinkUtils.oneOf(val, ['fillet', 'none', 'round'])},                              // 设定弹出框的圆角（fillet）方角（none）圆形（round）

            disabled: {type: Boolean},
            noPreview: {type: Boolean},                     //是否禁用点击图片放大显示
            customUpload: {type: Function},                 //自定义获取图片的函数

            custom: {type: Boolean},                        //兼容老窖的写法，自定义获取图片的逻辑
			handleUpload: {type: Function},                 //表格扩展列上传
        },
        computed: {
			fileStatus(){
				if (!this.row) return false
				if (!!this.smallUrlKey) return !(this.row[this.smallUrlKey].indexOf('mp4') != -1 || this.row[this.smallUrlKey].indexOf('MP4') != -1)
			},
            bigUrl() {
                if (!this.row) return null
                if (!!this.bigUrlKey) return this.row[this.bigUrlKey]
                if (!!this.smallUrlKey) return this.row[this.smallUrlKey]
            },
            smallUrl() {
                if (!this.row) return null
                if (!!this.smallUrlKey) return this.row[this.smallUrlKey]
                if (!!this.bigUrlKey) return this.row[this.bigUrlKey]
            },
        },
        watch: {
            row(newVal, oldVal) {
                if (newVal !== oldVal) this.bakRow = LinkUtils.deepCopy(newVal)
            },
        },
        data() {
            return {
                bakRow: LinkUtils.deepCopy(this.row),
                loading: false,
            }
        },
        methods: {
            preview() {
                !this.noPreview && this.$slider.pick({picData: [this.bigUrl], picKey: null,})
            },
            reset() {
                this.row[this.idKey] = this.bakRow[this.idKey]
                !!this.bigUrlKey && (this.row[this.bigUrlKey] = this.bakRow[this.bigUrlKey])
                !!this.smallUrlKey && (this.row[this.smallUrlKey] = this.bakRow[this.smallUrlKey])
            },
            lv_delete() {
                this.row[this.idKey] = null
                !!this.bigUrlKey && (this.row[this.bigUrlKey] = null)
                !!this.smallUrlKey && (this.row[this.smallUrlKey] = null)
				this.$emit('delete', '');
            },
            async lv_upload() {

                this.$emit('upload', {
                    row: this.row,
                    headId: this.headId,
                    moduleType: this.moduleType,
                    idKey: this.idKey,
                    bigUrlKey: this.bigUrlKey,
                    smallUrlKey: this.smallUrlKey,
                })

                if (!!this.custom) return

                try {
                    let attachment;
                    if (!!this.customUpload) {
                        const {row, idKey, bigUrlKey, smallUrlKey} = this
                        attachment = await this.customUpload({row, idKey, bigUrlKey, smallUrlKey})
                    } else {
                        attachment = await this.$file.getImageAutoUpload({
                            headId: this.headId,
                            moduleType: this.moduleType,
                            beforeUpload: () => this.loading = true,
                            afterUpload: () => this.loading = false
                        })
                        this.$emit('upload-success', attachment)
                    }
                    // console.log(attachment)
                    if (!attachment) {
                        console.log('do nothing because no return attachment')
                        return
                    }
                    this.$set(this.row, this.idKey, attachment.id)
                    !!this.bigUrlKey && (this.$set(this.row, this.bigUrlKey, attachment.bigurl))
                    !!this.smallUrlKey && (this.$set(this.row, this.smallUrlKey, attachment.smallurl))
                } catch (e) {
                    console.log(e)
                    this.$emit('upload-error', e)
                    this.loading = false
                }
            },
        },
    }
</script>

<style lang="scss">
	@include themeify {
		.link-img {
			display: inline-flex;
			vertical-align: middle;
			box-sizing: border-box;
			cursor: pointer;
			position: relative;
			border: solid 1px #f8f8f8;
			align-items: center;
			justify-content: center;
			background-color: white;

			img {
				height: 100%;
				width: 100%;
				object-fit: cover;
				object-position: center;
			}

			.link-img-loading {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background-color: rgba(black, 0.3);
				color: white;
				z-index: 2;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.link-img-empty-icon {
				color: #ddd;
				font-size: 30px;
			}

			@each $key, $value in $list-shape {
				&.link-img-#{$key} {
					border-radius: $value;
					overflow: hidden;
				}
			}

			&:hover {
				border: dashed 1px $color-primary;

				.link-img-operation {
					transform: translateY(0);
				}
			}

			&.link-img-disabled .link-img-operation {
				transform: translateY(100%);
			}

			.link-img-operation {
				@include transition-all-cubic-bezier;
				position: absolute;
				height: 50%;
				bottom: 0;
				left: 0;
				right: 0;
				display: flex;
				color: white;
				background-color: rgba(black, 0.25);
				transform: translateY(100%);

				& > div {
					flex: 1;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;

					&:hover {
						background-color: rgba(white, 0.3);
					}
				}
			}
		}

	}
</style>
